import React, { Component, PropTypes } from 'react';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import { SpinnerButton, GeneralTerms, PrivacyPolicy } from 'components';
import * as variables from 'frilans-finans/variables';

import LoginBottomElement from '../login-view/tabs/login-bottom-element';

class RegisterWithEidView extends Component {

  static propTypes = {
    switchView: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      hasAgreedToPrivacyPolicy: false,
      isLoading: false
    };

    this.toggleHasAgreedToPrivacyPolicy = this.toggleHasAgreedToPrivacyPolicy.bind(this);
    this.openEIDAuth = this.openEIDAuth.bind(this);
  }

  openEIDAuth () {
    this.setState({
      isLoading: true
    });
    const returnProtocol = variables.appEnv === 'development' ? 'http://' : 'https://';
    const returnUrl = returnProtocol + variables.appUrl + '/eid-link-register';
    const eidAuthUrl = variables.eidUrl + '/start-redirect?return_url=' + returnUrl;
    window.location = eidAuthUrl;
  }

  toggleHasAgreedToPrivacyPolicy () {
    this.setState({
      hasAgreedToPrivacyPolicy: !this.state.hasAgreedToPrivacyPolicy
    });
  }

  renderGeneralTerms () {
    return (
      <div>
        <div className="pt-20">
          <GeneralTerms />
        </div>
      </div>
    );
  }

  renderPrivacyPolicy () {
    return (<div className='checkbox-holder checkbox-container'>
      <input
        id='privacy-policy'
        type='checkbox'
        name='hasAgreedToPrivacyPolicy'
        onClick={this.toggleHasAgreedToPrivacyPolicy}
      />
      <label htmlFor='privacy-policy'>
        <span></span>
      </label>
      <PrivacyPolicy />
    </div>);
  }

  renderCreateAccountWithBankIdButton () {
    const isDisabled = !this.state.hasAgreedToPrivacyPolicy;

    return <SpinnerButton
      id='login-button'
      text={proxyCounterpart('CREATE_ACCOUNT_WITH_BANKID')}
      loading={this.state.isLoading}
      classes='btn cover'
      callback={this.openEIDAuth}
      disabled={isDisabled}
    />;
  }

  render () {
    return (
      <div>
        {this.renderPrivacyPolicy()}
        <div>
          {this.renderCreateAccountWithBankIdButton()}
          {this.renderGeneralTerms()}
          <LoginBottomElement
            isBankID
            handleClick={this.props.switchView}
          />
        </div>
      </div>
    );
  }
}

export default RegisterWithEidView;



/** WEBPACK FOOTER **
 ** ./src/views/register-view/register-with-eid-view.js
 **/